
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getWorkorderStatus} from 'sr/utils/api/masterData/WorkorderStatus/getWorkorderStatus'
export const fetchWorkorderStatus = createAsyncThunk(
  'getWorkorderStatus',
  async () => {
    const response = await getWorkorderStatus()
    return response?.data
  }
)


